import {
  useReactMutation,
  getPostServicePromise,
  useTranslation
} from '@invision/core';
import type {
  SecurityRetrieveIdentityProviderRequest,
  SecurityRetrieveIdentityProviderResponse
} from 'invApi';

export function useRetrieveIdentityProviderMutation() {
  const { t } = useTranslation();

  return useReactMutation<
    SecurityRetrieveIdentityProviderResponse,
    SecurityRetrieveIdentityProviderRequest
  >(
    ['retrieveIdentityProvider'],
    (request: SecurityRetrieveIdentityProviderRequest) =>
      getPostServicePromise(
        { path: 'Security/RetrieveIdentityProvider' },
        {
          payload: request,
          faults: {
            '111': t('Identity provider configuration not found'),
            // @ts-ignore not included in the documentation
            '117-11702': t('Login Revoked')
          }
        }
      ),
    {},
    {
      useLoadingIndicator: true,
      errorHandling: 'unhandled' // Let the component handle errors
    }
  );
}
